import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Handbook = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.5C2.5 1.67157 3.17157 1 4 1H6.5H7H10.5H11H12C12.8284 1 13.5 1.67157 13.5 2.5V12C13.5 12.2761 13.2761 12.5 13 12.5V14C13.2761 14 13.5 14.2239 13.5 14.5C13.5 14.7761 13.2761 15 13 15H4.25C3.2835 15 2.5 14.2165 2.5 13.25C2.5 13.195 2.50254 13.1405 2.50751 13.0868C2.50257 13.0586 2.5 13.0296 2.5 13V2.5ZM10 2H7.5V5.76211L8.32052 4.73646C8.5407 4.46123 8.9593 4.46123 9.17948 4.73646L10 5.76211V2ZM6.5 2V6.90242C6.5 7.46959 7.21421 7.72012 7.56852 7.27724L8.75 5.80039L9.93148 7.27724C10.2858 7.72012 11 7.46959 11 6.90242V2H12C12.2761 2 12.5 2.22386 12.5 2.5V11.5H4.25C3.9816 11.5 3.72731 11.5604 3.5 11.6684V2.5C3.5 2.22386 3.72386 2 4 2H6.5ZM4.25 12.5H12V14H4.25C3.83579 14 3.5 13.6642 3.5 13.25C3.5 12.8358 3.83579 12.5 4.25 12.5Z"
      />
    </svg>
  )
})

export default Handbook
